import { AnnotateTag, Span } from '../types/annotate-types';
import SplitTag from './SplitTag';
import { TextAnnotateProps } from './TextAnnotate';
import { generalHandleMouseUp, generalSplitClick, generateSplits } from './utils/annotation-utils';

export interface AnnotatorProps<T> extends TextAnnotateProps<T> {
  isBlendable: boolean;
}

const TextAnnotator = <T extends AnnotateTag>({ content, value, isBlendable, onChange, getSpan, style, className }: AnnotatorProps<T>) => {
  const annotateGetSpan = (span: T): T => {
    if (getSpan) return getSpan(span) as T;
    return { start: span.start, end: span.end } as T;
  };

  const decoratedMouseUp = () => {
    return () => generalHandleMouseUp(content, value, isBlendable, annotateGetSpan, onChange);
  };

  const decoratedHandleSplitClick = () => {
    return (split: Span) => generalSplitClick(split, value, isBlendable, onChange);
  };

  const handleMouseUp = decoratedMouseUp();
  const handleSplitClick = decoratedHandleSplitClick();

  const splits = generateSplits(content, value, isBlendable);

  const onMouseDown = () => {
    document.addEventListener(
      'mouseup',
      () => {
        handleMouseUp();
      },
      { once: true }
    );
  };

  return (
    <div className={className} style={style} onMouseDown={onMouseDown} onMouseUp={handleMouseUp}>
      {splits.map((split) => (
        <SplitTag key={`${split.start}-${split.end}`} {...split} onClick={handleSplitClick} />
      ))}
    </div>
  );
};

export default TextAnnotator;
